import * as R from "ramda";
import { stringCell, numberCell, styleFormat } from "./helper";

const excelHeader = ({ sheet }: { sheet: any }) => {
  sheet.row(1).freeze();
  sheet
    .cell(1, 1)
    .string("PVI")
    .style(styleFormat);
  sheet
    .cell(1, 2)
    .string("DatetimeOffset")
    .style(styleFormat);
  sheet
    .cell(1, 3)
    .string("Disponibilita")
    .style(styleFormat);
  sheet
    .cell(1, 4)
    .string("CapacitaMassima")
    .style(styleFormat);

  return sheet;
};

const excelBody = ({ sheet, data }: { sheet: any; data: any }) => {
  data.records.map((rowData: any, ri: number) => {
    const info = { sheet, rowData, rowIndex: R.add(ri, 2) };
    stringCell({
      ...info,
      colIndex: 1,
      rowData: data,
      path: ["pvi"]
    });
    stringCell({ ...info, colIndex: 2, path: ["dateTimeOffset"] });
    numberCell({
      ...info,
      colIndex: 3,
      path: ["disponibilita"]
    });
    numberCell({
      ...info,
      colIndex: 4,
      path: ["capacitaMassima"]
    });
    return true;
  });
  return sheet;
};

type DisponibilitaCapacitaMassimaType = { sheet: any; data: any };

export const disponibilitaCapacitaMassima = ({
  sheet,
  data
}: DisponibilitaCapacitaMassimaType) => {
  excelHeader({ sheet });
  excelBody({ sheet, data });
  return sheet;
};

export default disponibilitaCapacitaMassima;
